import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { OutputDecoderType } from '@/types/decoder'

const STATION_PURPOSE_NAMES = new Set(['irrigation', 'nonirrigation'])

const normalisePurposeName = (value: unknown) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[\s_-]+/g, '')

const purposeIdsByInterface = new Map<number, Promise<number[]>>()

const loadStationDecoderPurposeIds = async (
  interfaceId: number,
): Promise<number[]> => {
  const res: any = await controllerDataConfigApi.getDecoderType({
    interfaceId,
    PageSize: 100,
  })
  const purposes: { id?: unknown; name?: unknown }[] = res?.data?.data ?? []
  const ids = purposes
    .filter((purpose) =>
      STATION_PURPOSE_NAMES.has(normalisePurposeName(purpose?.name)),
    )
    .map((purpose) => Number(purpose?.id))
    .filter((id) => Number.isFinite(id) && id > 0)
  return ids.includes(OutputDecoderType.IRRIGATION)
    ? ids
    : [OutputDecoderType.IRRIGATION, ...ids]
}

export const fetchStationDecoderPurposeIds = async (
  interfaceId: number,
): Promise<number[]> => {
  const cached = purposeIdsByInterface.get(interfaceId)
  if (cached) return cached

  const pending = loadStationDecoderPurposeIds(interfaceId)
  purposeIdsByInterface.set(interfaceId, pending)
  try {
    return await pending
  } catch (error) {
    console.error('Station decoder purposes failed to load:', error)
    purposeIdsByInterface.delete(interfaceId)
    return [OutputDecoderType.IRRIGATION]
  }
}

export const clearStationDecoderPurposeIds = () => purposeIdsByInterface.clear()
